module.exports = __webpack_public_path__ + "img/user-helmet-safety.c4bd76c1.svg";